export default __webpack_public_path__ + "static/media/shape.6422ce42.svg";